var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.403,
    height: 17.133,
    viewBox: "0 0 20.403 17.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3387",
    "data-name": "Group 3387",
    transform: "translate(-9836.074 -3157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M186.733,133.806l-3.188,3.123a.933.933,0,0,1-1.322-1.318l1.076-1.069c.245-.243.164-.441-.181-.441h-4.285a.932.932,0,1,1,0-1.864h4.285c.343,0,.427-.2.181-.441l-1.076-1.07a.933.933,0,0,1,1.322-1.318l3.184,3.091A.906.906,0,0,1,186.733,133.806Zm-5.5-6.694a1.09,1.09,0,0,1-1.542,1.542,6.386,6.386,0,1,0,0,9.031,1.09,1.09,0,0,1,1.542,1.542,8.566,8.566,0,1,1,0-12.115Z",
    transform: "translate(9669.469 3032.397)",
    fill: "#2a2a2a",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e18c99331f6844ff5c23d906181df028.svg";
export { ForwardRef as ReactComponent };